export const ModuleTypes = {
  activationCodeCollection: 'activationCodeCollection',
  dateTimeCollection: 'dateTimeCollection',
  thankYou: 'thankYou',
  default: 'default',
};
